import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import styles from "../../styles/styles";
import { categoriesData } from "../../static/data";
import {
  AiOutlineHeart,
  AiOutlineSearch,
  AiOutlineShoppingCart,
  AiOutlineMessage,
  AiOutlinePlus,
  AiOutlineFilter,
  AiOutlineClose,
} from "react-icons/ai";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { BiMenuAltLeft } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { RxCross1 } from "react-icons/rx";
import DropDown from "./DropDown";
import Navbar from "./Navbar";
import { useSelector, useDispatch } from "react-redux";
import Cart from "../cart/Cart";
import Wishlist from "../Wishlist/Wishlist";
import Logo from "../../../src/Assests/images/logo.jpg";
import LanguageIcon from "@mui/icons-material/Language";
import usFlag from "../../../src/Assests/flags/us-flag.jpg";
import arabicFlag from "../../../src/Assests/flags/arabic-flag.png";
import tanzaniaFlag from "../../../src/Assests/flags/tanzania-flag.jpg";
import axios from "axios";
import { server } from "../../server";
import { addTocart } from "../../redux/actions/cart"; // Import the addTocart action
import { toast } from "react-toastify"; // Import toast for notifications

const Header = ({ activeHeading }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const { isSeller } = useSelector((state) => state.seller);
  const { wishlist } = useSelector((state) => state.wishlist);
  const { cart } = useSelector((state) => state.cart);
  const { allProducts } = useSelector((state) => state.products);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [active, setActive] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  const [openWishlist, setOpenWishlist] = useState(false);
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState("swahili");
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await axios.get(
          `${server}/conversation/get-all-conversation-seller/${user?._id}`,
          {
            withCredentials: true,
          }
        );

        const conversations = response.data.conversations;
        const unreadCount = conversations.reduce((count, conversation) => {
          if (conversation.lastMessageId !== user?._id) {
            return count + 1;
          }
          return count;
        }, 0);

        setUnreadMessagesCount(unreadCount);
      } catch (error) {
        console.error("Error fetching conversations:", error);
        setUnreadMessagesCount(0); // Ensure 0 is displayed when there is an error
      }
    };

    if (isAuthenticated) {
      fetchConversations();
    }
  }, [isAuthenticated, user]);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    const filteredProducts =
      allProducts &&
      allProducts.filter((product) =>
        product.name.toLowerCase().includes(term.toLowerCase())
      );
    setSearchData(filteredProducts);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 70) {
        setActive(true);
      } else {
        setActive(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLanguageChange = useCallback((lang) => {
    setLanguage(lang);
    setShowLanguageDropdown(false);
  }, []);

  const addToCartHandler = useCallback((product) => {
    const isItemExists = cart && cart.find((i) => i._id === product._id);
    if (isItemExists) {
      toast.error("Item already in cart!");
    } else {
      if (product.stock < 1) {
        toast.error("Product stock limited!");
      } else {
        const cartData = { ...product, qty: 1 };
        dispatch(addTocart(cartData));
        toast.success("Item added to cart successfully!");
      }
    }
  }, [cart, dispatch]);

  return (
    <>
      <div className={`${styles.section}`}>
        <div className="hidden 800px:h-[50px] 800px:my-[20px] 800px:flex items-center justify-between">
          <div>
            <Link to="/">
              <img src={Logo} alt="Logo" className="w-20" />
            </Link>
          </div>
          {/* search box */}
          <div className="w-[50%] relative">
            <input
              type="text"
              placeholder="Search Product..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="h-[40px] w-full px-2 border-[#3957db] border-[2px] rounded-md"
            />
            <AiOutlineSearch
              size={30}
              className="absolute right-2 top-1.5 cursor-pointer"
            />
            {searchData.length > 0 && (
              <div className="absolute w-full max-h-[400px] overflow-y-auto bg-white shadow-lg z-10 p-4">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-gray-700 font-medium">
                    {searchData.length} items found
                  </span>
                  <button
                    className="flex items-center space-x-1 text-gray-700 hover:text-gray-900"
                    onClick={() => setShowFilter(true)}
                  >
                    <AiOutlineFilter size={20} />
                    <span>Filter</span>
                  </button>
                </div>
                {searchData.map((i, index) => (
                  <div
                    key={index}
                    className="w-full flex items-center py-3 border-b border-gray-200"
                  >
                    <Link to={`/product/${i._id}`} className="flex-grow">
                      <div className="flex items-center">
                        <img
                          src={`${i.images[0]?.url}`}
                          alt=""
                          className="w-[40px] h-[40px] mr-[10px] object-cover"
                        />
                        <div>
                          <h1 className="text-gray-800">{i.name}</h1>
                          <p className="text-gray-600">TZS {i.discountPrice}</p>
                        </div>
                      </div>
                    </Link>
                    <button
                      className="ml-4 flex items-center justify-center w-10 h-10 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-200"
                      onClick={() => addToCartHandler(i)}
                    >
                      <AiOutlineShoppingCart size={20} />
                      <AiOutlinePlus size={10} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={`${styles.button}`}>
            <Link to={`${isSeller ? "/dashboard" : "/shop-login"}`}>
              <h1 className="text-[#fff] flex items-center">
                {isSeller ? "Go Dashboard" : "Become Seller"}{" "}
                <IoIosArrowForward className="ml-1" />
              </h1>
            </Link>
          </div>
        </div>
      </div>
      <div
        className={`${
          active ? "shadow-sm fixed top-0 left-0 z-10" : ""
        } transition hidden 800px:flex items-center justify-between w-full bg-[#3321c8] h-[70px]`}
      >
        <div
          className={`${styles.section} relative ${styles.noramlFlex} justify-between`}
        >
          {/* categories */}
          <div onClick={() => setDropDown(!dropDown)}>
            <div className="relative h-[60px] mt-[10px] w-[270px] hidden 1000px:block">
              <BiMenuAltLeft size={30} className="absolute top-3 left-2" />
              <button
                className={`h-[100%] w-full flex justify-between items-center pl-10 bg-white font-sans text-lg font-[500] select-none rounded-t-md`}
              >
                All Categories
              </button>
              <IoIosArrowDown
                size={20}
                className="absolute right-2 top-4 cursor-pointer"
                onClick={() => setDropDown(!dropDown)}
              />
              {dropDown ? (
                <DropDown
                  categoriesData={categoriesData}
                  setDropDown={setDropDown}
                />
              ) : null}
            </div>
          </div>
          {/* navitems */}
          <div className={`${styles.noramlFlex}`}>
            <Navbar active={activeHeading} />
          </div>

          <div className="flex items-center space-x-4">
            {/* Messages Icon */}
            <div className={`${styles.noramlFlex}`}>
              <div
                className="relative cursor-pointer mr-[15px]"
                onClick={() => (window.location.href = "/inbox")}
              >
                <AiOutlineMessage size={30} color="rgb(255 255 255 / 83%)" />
                <span className="absolute right-0 top-0 rounded-full bg-[#3bc177] w-4 h-4 p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
                  {unreadMessagesCount}
                </span>
              </div>
            </div>

            <div className={`${styles.noramlFlex}`}>
              <div
                className="relative cursor-pointer mr-[15px]"
                onClick={() => setOpenWishlist(true)}
              >
                <AiOutlineHeart size={30} color="rgb(255 255 255 / 83%)" />
                <span className="absolute right-0 top-0 rounded-full bg-[#3bc177] w-4 h-4 p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
                  {wishlist && wishlist.length}
                </span>
              </div>
            </div>

            <div className={`${styles.noramlFlex}`}>
              <div
                className="relative cursor-pointer mr-[15px]"
                onClick={() => setOpenCart(true)}
              >
                <AiOutlineShoppingCart
                  size={30}
                  color="rgb(255 255 255 / 83%)"
                />
                <span className="absolute right-0 top-0 rounded-full bg-[#3bc177] w-4 h-4 p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
                  {cart && cart.length}
                </span>
              </div>
            </div>

            <div className={`${styles.noramlFlex}`}>
              <div className="relative cursor-pointer mr-[15px]">
                {isAuthenticated ? (
                  <Link to="/profile">
                    <img
                      src={`${user?.avatar?.url}`}
                      className="w-[35px] h-[35px] rounded-full"
                      alt=""
                    />
                  </Link>
                ) : (
                  <Link to="/login">
                    <CgProfile size={30} color="rgb(255 255 255 / 83%)" />
                  </Link>
                )}
              </div>
            </div>

            <div className={`${styles.noramlFlex}`}>
              <div
                className="relative cursor-pointer text-blue-600"
                onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
              >
                <LanguageIcon fontSize="large" />
              </div>
              {showLanguageDropdown && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                  <div
                    className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleLanguageChange("swahili")}
                  >
                    <img
                      src={tanzaniaFlag}
                      alt="Tanzania Flag"
                      className="w-4 h-4 mr-2"
                    />
                    Swahili
                  </div>
                  <div
                    className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleLanguageChange("english")}
                  >
                    <img src={usFlag} alt="US Flag" className="w-4 h-4 mr-2" />
                    English
                  </div>
                  <div
                    className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                    onClick={() => handleLanguageChange("arabic")}
                  >
                    <img
                      src={arabicFlag}
                      alt="Arabic Flag"
                      className="w-4 h-4 mr-2"
                    />
                    Arabic
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* cart popup */}
          {openCart && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
              <Cart setOpenCart={setOpenCart} />
            </div>
          )}

          {/* wishlist popup */}
          {openWishlist ? (
            <Wishlist setOpenWishlist={setOpenWishlist} />
          ) : null}
        </div>
      </div>

      {/* mobile header */}
      <div
        className={`${
          active ? "shadow-sm fixed top-0 left-0 z-10" : ""
        } w-full h-[60px] bg-[#fff] z-50 top-0 left-0 shadow-sm 800px:hidden`}
      >
        <div className="w-full flex items-center justify-between px-4">
          <div className="flex items-center">
            <BiMenuAltLeft
              size={40}
              className="cursor-pointer"
              onClick={() => setOpen(true)}
            />
            <Link to="/" className="ml-4">
              <img
                src={Logo}
                alt="Logo"
                className="h-12 cursor-pointer object-contain"
              />
            </Link>
          </div>
          <div className="flex items-center space-x-4">
            <AiOutlineSearch
              size={30}
              className="cursor-pointer"
              onClick={() => setOpen(true)}
            />
            <div
              className="relative cursor-pointer"
              onClick={() => setOpenCart(true)}
            >
              <AiOutlineShoppingCart size={30} />
              <span className="absolute right-0 top-0 rounded-full bg-[#3bc177] w-4 h-4 p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
                {cart && cart.length}
              </span>
            </div>
            <div
              className="relative cursor-pointer text-blue-600"
              onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
            >
              <LanguageIcon fontSize="large" />
            </div>
            {showLanguageDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10">
                <div
                  className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleLanguageChange("swahili")}
                >
                  <img
                    src={tanzaniaFlag}
                    alt="Tanzania Flag"
                    className="w-4 h-4 mr-2"
                  />
                  Swahili
                </div>
                <div
                  className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleLanguageChange("english")}
                >
                  <img src={usFlag} alt="US Flag" className="w-4 h-4 mr-2" />
                  English
                </div>
                <div
                  className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleLanguageChange("arabic")}
                >
                  <img
                    src={arabicFlag}
                    alt="Arabic Flag"
                    className="w-4 h-4 mr-2"
                  />
                    Arabic
                  </div>
                </div>
              )}
            </div>
          </div>
  
          {/* header sidebar */}
          {open && (
            <div className={`fixed w-full bg-[#0000005f] z-20 h-full top-0 left-0`}>
              <div className="fixed w-full bg-[#fff] h-screen top-0 left-0 z-10 overflow-y-scroll p-4">
                <div className="w-full flex justify-between p-3">
                  <div
                    className="relative mr-[15px]"
                    onClick={() => setOpenWishlist(true) || setOpen(false)}
                  >
                    <AiOutlineHeart size={30} className="mt-5 ml-3" />
                    <span className="absolute right-0 top-0 rounded-full bg-[#3bc177] w-4 h-4 p-0 m-0 text-white font-mono text-[12px] leading-tight text-center">
                      {wishlist && wishlist.length}
                    </span>
                  </div>
                  <RxCross1 size={30} className="ml-4 mt-5" onClick={() => setOpen(false)} />
                </div>
  
                <div className="my-8 w-[92%] m-auto h-[40px] relative">
                  <input
                    type="search"
                    placeholder="Search Product..."
                    className="h-[40px] w-full px-2 border-[#3957db] border-[2px] rounded-md"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  {searchData.length > 0 && (
                    <div className="absolute w-full max-h-[400px] overflow-y-auto bg-white shadow-lg z-10 p-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-gray-700 font-medium">
                          {searchData.length} items found
                        </span>
                        <button
                          className="flex items-center space-x-1 text-gray-700 hover:text-gray-900"
                          onClick={() => setShowFilter(true)}
                        >
                          <AiOutlineFilter size={20} />
                          <span>Filter</span>
                        </button>
                      </div>
                      {searchData.map((i) => (
                        <div
                          key={i._id}
                          className="w-full flex items-center py-3 border-b border-gray-200"
                        >
                          <Link
                            to={`/product/${i._id}`}
                            className="flex-grow"
                            onClick={() => setOpen(false)}
                          >
                            <div className="flex items-center">
                              <img
                                src={`${i.images[0]?.url}`}
                                alt=""
                                className="w-[40px] h-[40px] mr-[10px] object-cover"
                              />
                              <div>
                                <h1 className="text-gray-800">{i.name}</h1>
                                <p className="text-gray-600">TZS {i.discountPrice}</p>
                              </div>
                            </div>
                          </Link>
                          <button
                            className="ml-4 flex items-center justify-center w-10 h-10 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-200"
                            onClick={() => addToCartHandler(i)}
                          >
                            <AiOutlineShoppingCart size={20} />
                            <AiOutlinePlus size={10} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
  
                <Navbar active={activeHeading} />
                <div className={`${styles.button} ml-4 !rounded-[4px]`}>
                  <Link to={`${isSeller ? "/dashboard" : "/shop-create"}`}>
                    <h1 className="text-[#fff] flex items-center">
                      {isSeller ? "Go Dashboard" : "Become Seller"}{" "}
                      <IoIosArrowForward className="ml-1" />
                    </h1>
                  </Link>
                </div>
                <br />
                <br />
                <br />
  
                <div className="flex w-full justify-center">
                  {isAuthenticated ? (
                    <div>
                      <Link to="/profile">
                        <img
                          src={`${user.avatar?.url}`}
                          alt=""
                          className="w-[60px] h-[60px] rounded-full border-[3px] border-[#0eae88]"
                        />
                      </Link>
                    </div>
                  ) : (
                    <>
                      <Link to="/login" className="text-[18px] pr-[10px] text-[#000000b7]">
                        Login /
                      </Link>
                      <Link to="/sign-up" className="text-[18px] text-[#000000b7]">
                        Sign up
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
  
        {/* mobile cart popup */}
        {openCart && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
            <Cart setOpenCart={setOpenCart} />
          </div>
        )}
  
        {/* mobile wishlist popup */}
        {openWishlist && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-end">
            <Wishlist setOpenWishlist={setOpenWishlist} />
          </div>
        )}
  
        {/* filter modal */}
        {showFilter && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-1/2 p-5 relative">
              <button
                className="absolute top-2 right-2"
                onClick={() => setShowFilter(false)}
              >
                <AiOutlineClose size={25} />
              </button>
              <h2 className="text-xl font-semibold mb-4">Filter</h2>
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Price
                </label>
                <input type="range" min="0" max="100" className="w-full" />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">
                  Sort by
                </label>
                <div className="space-y-2">
                  <label className="flex items-center space-x-2">
                    <input type="radio" name="sort" />
                    <span>Price: low to high</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input type="radio" name="sort" />
                    <span>Price: high to low</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input type="radio" name="sort" />
                    <span>Ascending</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input type="radio" name="sort" />
                    <span>Descending</span>
                  </label>
                </div>
              </div>
              <div className="flex justify-end space-x-2">
                <button
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded"
                  onClick={() => setShowFilter(false)}
                >
                  Reset
                </button>
                <button
                  className="px-4 py-2 bg-blue-600 text-white rounded"
                  onClick={() => setShowFilter(false)}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  };
  
  export default Header;
